<template>
  <CardPrimary
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <HeaderMediumPrimary :style="style.header">
      Recently joined
    </HeaderMediumPrimary>
    <BeatLoaderPrimary
      v-if="isLoading"
      :style="style.loader"
    />
    <div
      v-else
      v-for="(tenantUser, index) in tenantUsers.slice(0, joinListLength)"
      :key="index"
      :style="style.row"
    >
      <UserImagePrimary :tenantUser="tenantUser" />
      <LinkNamePrimary
        :tenantUser="tenantUser"
        :truncate="true"
        :style="style.name"
      >
        {{ tenantUser.user.firstName }} {{ tenantUser.user.lastName }}
      </LinkNamePrimary>
      <TextMutedSecondary>
        {{ getDurationFromNow(tenantUser.joinedAt) }}
      </TextMutedSecondary>
    </div>
  </CardPrimary>
</template>

<script>
  import BeatLoaderPrimary from '@modules/v2/loader/beat-loader-primary'
  import CardPrimary from '@modules/v2/card/card-primary'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import LinkNamePrimary from '@modules/v2/link/link-name-primary'
  import TextMutedSecondary from '@modules/v2/text/text-muted-secondary'
  import UserImagePrimary from '@modules/v2/image/user-image-primary'
  import { getDurationFromNow } from '@js/date-utils'
  import { Layout } from '@js/styles'
  import { LENGTH_LIMITS } from '@js/constants'
  import { mapGetters } from 'vuex'

  export default {
    name: 'JoinList',
    inheritAttrs: false,
    components: {
      BeatLoaderPrimary,
      CardPrimary,
      HeaderMediumPrimary,
      LinkNamePrimary,
      TextMutedSecondary,
      UserImagePrimary,
    },
    props: {
      isLoading: {
        type: Boolean,
        required: false,
        default: false,
      },
      tenantUsers: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        joinListLength: LENGTH_LIMITS.JOIN_LIST_MAX,
        style: {
          card: {
            padding: Layout.space.md,
          },
          header: {
            padding: `0 0 ${Layout.space.md} 0`,
          },
          name: {
            margin: `0 ${Layout.space.sm}`,
            flex: 1,
          },
          loader: {
            height: '120px',
          },
          row: {
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'nowrap',
            height: '40px',
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.header,
        {
          border: `solid ${this.color.dark5()}`,
          borderWidth: '0 0 1px 0',
        },
      );
      Object.assign(
        this.style.row,
        {
          border: `solid ${this.color.dark5()}`,
          borderWidth: '0 0 1px 0',
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      getDurationFromNow: function (timestamp) {
        return getDurationFromNow(timestamp, true);
      },
    },
  };
</script>



<!--
<template>
  <CardPrimary v-bind="cardAttrs">
    <div :style="headerContainerStyle">
      <HeaderMediumPrimary :style="headerStyle">
        Recently Joined
      </HeaderMediumPrimary>
    </div>
    <template v-if="isLoading">
      <LoaderPrimary :style="loaderStyle" />
    </template>
    <template v-else-if="tenantUsers.length > 0">
      <div
        v-for="(tenantUser, index) in tenantUsers.slice(0, joinListLength)"
        :key="index"
      >
        <JoinListRow :tenantUser="tenantUser" />
      </div>
    </template>
    <template v-else>
      <div :style="placeholderContainerStyle">
        <NoDataToShow :textBottom="true">
          No one has joined yet.
        </NoDataToShow>
      </div>
    </template>
  </CardPrimary>
</template>

<script>
  import CardPrimary from '@modules/card/card-primary'
  import HeaderMediumPrimary from '@modules/text/header-medium-primary'
  import JoinListRow from '@home/modules/join-list-row'
  import LoaderPrimary from '@modules/loader/loader-primary'
  import NoDataToShow from '@modules/error/no-data-to-show'
  import { Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'JoinList',
    components: {
      CardPrimary,
      HeaderMediumPrimary,
      JoinListRow,
      LoaderPrimary,
      NoDataToShow,
    },
    props: {
      isLoading: {
        type: Boolean,
        required: false,
        default: false,
      },
      tenantUsers: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        cardAttrs: {
          padding: Layout.space.md,
        },
        displayLength: 5,
        headerContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          padding: `0 0 ${Layout.space.md} 0`,
          width: '100%',
        },
        headerStyle: {
          display: 'block',
        },
        loaderStyle: {
          height: '120px',
        },
        placeholderContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          height: '240px',
          justifyContent: 'center',
          width: '100%',
        },
      };
    },
    created: function () {
      this.headerContainerStyle = {
        ...this.headerContainerStyle,
        border: `solid ${this.color.dark5()}`,
        borderWidth: '0 0 1px 0',
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapState({
        tenantUserId: state => state.tenantUser.id,
      }),
    },
  };
</script>
-->
